<template>
  <v-row
    class="px-10"
    align="center"
  >
    <v-col>
      <p class="mb-0">
        {{ $t(module.name + 'Description') }}
      </p>
    </v-col>
    <v-col
      class="ma-0 pa-0"
      cols="auto"
    >
      <v-switch
        v-model="active"
        color="primary"
        :name="module.name"
        inset
        dense
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
    name: 'PartnerModule',
    props: ['module'],
    computed: {
        active: {
            get () {
                return this.module.active
            },
            set () {
                this.$emit('change')
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
